import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Reparation from "../pages/reparation-volet-roulant/page";
import Depannage from "../pages/depannage-urgence/page";
import Pose from "../pages/pose-volet-roulant/page";
import MoteurSomfy from "../pages/moteur-somfy/page";
import MoteurNice from "../pages/moteur-nice/page";
import MotorisationSomfy from "../pages/motorisation-somfy/page";
import ElectrificationSomfy from "../pages/electrification-somfy/page";
import ElectrificationNice from "../pages/electrification-nice/page";
import SangleVoletRoulant from "../pages/sangle-volet-roulant/page";
import CordonVoletRoulant from "../pages/cordon-volet-roulant/page";
import TablierVoletRoulant from "../pages/tablier-volet-roulant/page";
import TelecommandeVoletRoulant from "../pages/telecommande-volet-roulant/page";
import MoteurBubendorff from "../pages/moteur-bubendorff/page";
import MoteurProfalux from "../pages/moteur-profalux/page";
import ReparationVoletElectrique from "../pages/reparation-volet-electrique/page";
import ManivelleVoletRoulant from "../pages/manivelle-volet-roulant/page";
import CoffreVoletRoulant from "../pages/coffre-volet-roulant/page";
import Tarifs from "../pages/tarifs/page";
import Avis from "../pages/avis/page";
import Contact from "../pages/contact/page";
import Merci from "../pages/merci/page";
import Schiltigheim from "../pages/schiltigheim/page";
import Selestat from "../pages/selestat/page";
import Bischheim from "../pages/bischheim/page";
import Bischwiller from "../pages/bischwiller/page";
import Saverne from "../pages/saverne/page";
import IllkirchGraffenstaden from "../pages/illkirch-graffenstaden/page";
import Lingolsheim from "../pages/lingolsheim/page";
import Ostwald from "../pages/ostwald/page";
import Obernai from "../pages/obernai/page";
import Hoenheim from "../pages/hoenheim/page";
import Erstein from "../pages/erstein/page";
import Brumath from "../pages/brumath/page";
import Molsheim from "../pages/molsheim/page";
import Geispolsheim from "../pages/geispolsheim/page";
import Eckbolsheim from "../pages/eckbolsheim/page";
import Souffelweyersheim from "../pages/souffelweyersheim/page";
import Wissembourg from "../pages/wissembourg/page";
import Barr from "../pages/barr/page";
import ZonesDIntervention from "../pages/zones-d-intervention/page";
import Haguenau from "../pages/haguenau/page";
import MentionsLegales from "../pages/mentions-legales/page";
import PolitiqueConfidentialite from "../pages/politique-confidentialite/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/merci",
    element: <Merci />,
  },
  {
    path: "/reparation-volet-roulant",
    element: <Reparation />,
  },
  {
    path: "/depannage-urgence",
    element: <Depannage />,
  },
  {
    path: "/pose-volet-roulant",
    element: <Pose />,
  },
  {
    path: "/moteur-somfy",
    element: <MoteurSomfy />,
  },
  {
    path: "/moteur-nice",
    element: <MoteurNice />,
  },
  {
    path: "/motorisation-somfy",
    element: <MotorisationSomfy />,
  },
  {
    path: "/electrification-somfy",
    element: <ElectrificationSomfy />,
  },
  {
    path: "/electrification-nice",
    element: <ElectrificationNice />,
  },
  {
    path: "/sangle-volet-roulant",
    element: <SangleVoletRoulant />,
  },
  {
    path: "/cordon-volet-roulant",
    element: <CordonVoletRoulant />,
  },
  {
    path: "/tablier-volet-roulant",
    element: <TablierVoletRoulant />,
  },
  {
    path: "/telecommande-volet-roulant",
    element: <TelecommandeVoletRoulant />,
  },
  {
    path: "/tarifs",
    element: <Tarifs />,
  },
  {
    path: "/avis",
    element: <Avis />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/schiltigheim",
    element: <Schiltigheim />,
  },
  {
    path: "/selestat",
    element: <Selestat />,
  },
  {
    path: "/bischheim",
    element: <Bischheim />,
  },
  {
    path: "/bischwiller",
    element: <Bischwiller />,
  },
  {
    path: "/saverne",
    element: <Saverne />,
  },
  {
    path: "/moteur-bubendorff",
    element: <MoteurBubendorff />,
  },
  {
    path: "/moteur-profalux",
    element: <MoteurProfalux />,
  },
  {
    path: "/reparation-volet-electrique",
    element: <ReparationVoletElectrique />,
  },
  {
    path: "/manivelle-volet-roulant",
    element: <ManivelleVoletRoulant />,
  },
  {
    path: "/coffre-volet-roulant",
    element: <CoffreVoletRoulant />,
  },
  {
    path: "/zones-d-intervention",
    element: <ZonesDIntervention />,
  },
  {
    path: "/haguenau",
    element: <Haguenau />,
  },
  {
    path: "/illkirch-graffenstaden",
    element: <IllkirchGraffenstaden />,
  },
  {
    path: "/lingolsheim",
    element: <Lingolsheim />,
  },
  {
    path: "/ostwald",
    element: <Ostwald />,
  },
  {
    path: "/obernai",
    element: <Obernai />,
  },
  {
    path: "/hoenheim",
    element: <Hoenheim />,
  },
  {
    path: "/erstein",
    element: <Erstein />,
  },
  {
    path: "/brumath",
    element: <Brumath />,
  },
  {
    path: "/molsheim",
    element: <Molsheim />,
  },
  {
    path: "/geispolsheim",
    element: <Geispolsheim />,
  },
  {
    path: "/eckbolsheim",
    element: <Eckbolsheim />,
  },
  {
    path: "/souffelweyersheim",
    element: <Souffelweyersheim />,
  },
  {
    path: "/wissembourg",
    element: <Wissembourg />,
  },
  {
    path: "/barr",
    element: <Barr />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/politique-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;